import {
  PaymentMethodState,
  ServiceActivation,
  useRemovePaymentMethodV2Mutation,
} from '../../../../../../codegen/vehicles';
import Button from '@rio-cloud/rio-uikit/Button';
import { ServiceCardDetails } from './ServiceCardDetails';
import map from 'lodash/map';
import isEmpty from 'lodash/isEmpty';
import { filter } from 'lodash';
import { useAppDispatch } from '../../../../../../state/hooks';
import { useServiceConfigurationFormContext } from '../ServiceConfigurationForm';
import { useLoadedVehicles } from '../../../../../../state/vehicles/useVehicles';
import { openRemoveConfirmationDialog } from '../../../../state/onboardingUiSlice';
import { ErrorMessagePanel } from '../../../../../../components/ErrorMessagePanel';
import { PaymentMethod } from '../../../../../../models';
import classNames from 'classnames';

type ServiceCardPanelProps = {
  vehicleId: string;
  paymentMethod: PaymentMethod;
  callbackAfterDelete?: () => void;
};

export const ServiceCardPanel = ({
  vehicleId,
  paymentMethod,
  callbackAfterDelete,
}: ServiceCardPanelProps) => {
  const dispatch = useAppDispatch();
  const {
    removePaymentMethod: removePaymentMethodFromForm,
    getServiceActivations,
  } = useServiceConfigurationFormContext();
  const [callRemovePaymentMethodMutation] = useRemovePaymentMethodV2Mutation();

  const { removePaymentMethod: removePaymentMethodFromState } =
    useLoadedVehicles();

  const handleRemoveCard = (paymentMethodId: string) => {
    const serviceActivations = getServiceActivations();
    const serviceActivationsWithPaymentMethod: ServiceActivation[] = [];

    map(serviceActivations, (serviceActivation: ServiceActivation) => {
      const a = filter(serviceActivation.paymentMethodAssignments, {
        paymentMethodId,
      });
      if (!isEmpty(a)) {
        serviceActivationsWithPaymentMethod.push({
          ...serviceActivation,
        });
      }
    });

    if (!isEmpty(serviceActivationsWithPaymentMethod)) {
      dispatch(
        openRemoveConfirmationDialog({
          serviceActivationsWithPaymentMethod,
          paymentMethodId,
        }),
      );
    } else {
      removePaymentMethod(paymentMethodId);
    }
  };

  const removePaymentMethod = async (paymentMethodId: string) => {
    const result = await callRemovePaymentMethodMutation({
      vehicleId,
      paymentMethodId,
    });

    if ('error' in result) {
      return;
    }

    removePaymentMethodFromForm(paymentMethodId);
    removePaymentMethodFromState(vehicleId, paymentMethodId);

    if (callbackAfterDelete) {
      callbackAfterDelete();
    }
  };

  return (
    <div
      className="width-100pct border margin-top-10 padding-bottom-10 padding-top-10 padding-left-10 padding-right-20"
      data-testid={'onboarding-dialog-body-service-card-panel'}
    >
      <div className={classNames('display-flex', 'justify-content-between')}>
        <div className="display-flex align-items-center padding-right-10">
          <Button
            data-testid={'onboarding-dialog-body-removeServiceCardButton'}
            bsStyle={Button.MUTED}
            iconOnly
            onClick={() => handleRemoveCard(paymentMethod.id)}
            disabled={
              paymentMethod.state === PaymentMethodState.OnboardingPending
            }
          >
            <span className="rioglyph rioglyph-trash" />
          </Button>
        </div>
        <div style={{ width: '370px' }}>
          <ServiceCardDetails paymentMethod={paymentMethod} />
        </div>
      </div>
      {paymentMethod.state === PaymentMethodState.OnboardingFailure && (
        <div
          className={
            'full-width align-items-center padding-right-10 padding-left-10'
          }
        >
          <ErrorMessagePanel />
        </div>
      )}
    </div>
  );
};
